import { render, staticRenderFns } from "./rp-users-personal-photo.vue?vue&type=template&id=6fb40aac"
import script from "./rp-users-personal-photo.vue?vue&type=script&lang=js"
export * from "./rp-users-personal-photo.vue?vue&type=script&lang=js"
import style0 from "./rp-users-personal-photo.vue?vue&type=style&index=0&id=6fb40aac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports